import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BlogItem {
  id: string;
  [key: string]: unknown;
}

interface BlogState {
  blogs: BlogItem[];
}

const initialState: BlogState = {
  blogs: [],
};

export const blogSlice = createSlice({
  name: "blogSlice",
  initialState,
  reducers: {
    setBlogs: (state, action: PayloadAction<BlogItem>) => {
      const newBlog = action.payload;
      if (!state.blogs.some((blog) => blog.id === newBlog.id)) {
        state.blogs.push(newBlog);
      }
    },
  },
});

export const { setBlogs } = blogSlice.actions;

export default blogSlice.reducer;
